var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bill_addon clr" },
    [
      _c("standart", {
        key: "vacation_addon",
        attrs: {
          title: "Відпустка",
          is_active_result: false,
          is_active_problem: false,
        },
        scopedSlots: _vm._u([
          {
            key: "after_title",
            fn: function () {
              return [
                _c("div", { staticClass: "pre_title winner" }, [
                  _vm._v("\n                Період відпустки\n            "),
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "renage_times" },
                  [
                    _c("b-col", { attrs: { sm: "3" } }, [
                      _c("label", { attrs: { for: "vac_text" } }, [
                        _vm._v("період відпустки *"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("date-picker", {
                          attrs: {
                            "value-type": "format",
                            lang: _vm.d_lang,
                            range: "",
                            "first-day-of-week": 1,
                            shortcuts: _vm.shortcuts,
                            confirm: "",
                          },
                          on: {
                            confirm: _vm.set_preamblua,
                            clear: _vm.set_preamblua,
                          },
                          model: {
                            value: _vm.form.time_range,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "time_range", $$v)
                            },
                            expression: "form.time_range",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-valid-feedback",
                          { attrs: { state: _vm.can_format } },
                          [
                            _vm._v(
                              "\n                        терміном на " +
                                _vm._s(_vm.diff_days) +
                                " дні(в) в період з " +
                                _vm._s(
                                  _vm._f("formatDate")(_vm.form.time_range[0])
                                ) +
                                " по " +
                                _vm._s(
                                  _vm._f("formatDate")(_vm.form.time_range[1])
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "mem_preamblua",
            fn: function () {
              return [
                _c(
                  "b-row",
                  { staticClass: "doc_title", attrs: { id: "vac_text" } },
                  [
                    _c("b-col", { attrs: { sm: "3" } }, [
                      _c("label", { attrs: { for: "vac_text" } }, [
                        _vm._v("текст відпустки *"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-state",
                            disabled: !_vm.can_format,
                            state: _vm.can_format,
                            rows: "3",
                          },
                          model: {
                            value: _vm.mem_preamblua,
                            callback: function ($$v) {
                              _vm.mem_preamblua = $$v
                            },
                            expression: "mem_preamblua",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-invalid-feedback",
                          { attrs: { state: _vm.can_format } },
                          [
                            _vm._v(
                              "\n                        Спочатку оберіть інтервал дат\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.is_vac_start
                  ? _c(
                      "b-row",
                      { staticClass: "doc_title", attrs: { id: "user" } },
                      [
                        _c("b-col", { attrs: { sm: "3" } }, [
                          _c("label", { attrs: { for: "vac_text" } }, [
                            _vm._v("Тимчасово виконуючий обов'язки"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { sm: "9" } }, [
                          !_vm.obj_to_null(_vm.vac_user)
                            ? _c(
                                "div",
                                {
                                  staticClass: "u_list bg-info text-white",
                                  attrs: { id: "approve_list" },
                                },
                                [
                                  _c("div", { staticClass: "user_add" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "add user",
                                        on: { click: _vm.add_user },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa add_user fa-plus-square",
                                          attrs: {
                                            title: "",
                                            "data-type": "delegate_users",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v("Оберіть користувача"),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "user_to_fire bd-callout bd-callout-info",
                                },
                                [
                                  _vm.obj_to_null(this.vac_user)
                                    ? _c("user_block", {
                                        key: _vm.vac_user.id,
                                        attrs: {
                                          can_del: true,
                                          del_triger: _vm.remove_vac_user,
                                          user: _vm.vac_user,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }